import { call, put, takeEvery } from "redux-saga/effects";

// Login Redux States
import { LOGIN_USER, LOGOUT_USER } from "./actionTypes";
import {
  apiError,
  loginSuccess,
  logoutUserSuccess,
  updateProfileSwitch,
} from "../../actions";

import { ERROR_MESSAGE } from "../../../helpers/errors_helper";
import i18n from "../../../i18n";
import { APIClient } from "../../../helpers/api_helper";
import { encryptData } from "../../../helpers/crypto_utils";
import {
  setAuthorization,
  removeAuthorization,
} from "../../../helpers/api_helper";

const api = new APIClient();

function* loginUser({ payload: { user, history } }) {
  try {
    // Use unified login endpoint for all users
    const urlLogin = `${process.env.REACT_APP_API_BASE_URL}/auth/login`;

    const login = () =>
      api.create(urlLogin, {
        email: user.email,
        password: user.password,
        rememberMe: user.rememberMe,
      });

    const response = yield call(login);
    console.log(response, "> response");

    if (response.token !== undefined) {
      // Create user auth object with new response structure
      const authUser = {
        token: response.token,
        userProfile: {
          email: response.identifier || response.user?.email,
          first_name: response.firstName || response.user?.firstName,
          last_name: response.lastName || response.user?.lastName,
          profilePictureUrl: response.user?.profilePictureUrl,
        },
        // Add tenant info from backend response
        ...(response.tenants && { tenants: response.tenants }),
        ...(response.tenant && { tenant: response.tenant }),
        roles: response.user?.roles,
        // Add role flags
        isSuperAdmin: response.user?.roles?.includes("SUPER_ADMIN") || false,
        isAdmin:
          response.user?.roles?.includes("ADMIN") ||
          response.user?.roles?.includes("SUPER_ADMIN") ||
          false,
        isTenant:
          response.user?.roles?.includes("TENANT_ADMIN") ||
          response.user?.roles?.includes("TENANT_USER") ||
          false,
      };

      console.log(authUser, "> authUser");
      // Store auth data based on remember me preference
      const storage = user.rememberMe ? localStorage : sessionStorage;
      storage.setItem("authUser", encryptData(authUser));

      // Set authorization header
      setAuthorization(response.token);

      // Dispatch success and redirect
      yield put(loginSuccess());
      history.push("/dashboard");
    } else {
      // Handle specific error cases
      if (response?.message === "DISABLED_COMPANY_ERROR") {
        window.location.href = "/403";
      } else if (response?.message === "DELETED_COMPANY_ERROR") {
        window.location.href = "/404";
      } else {
        yield put(apiError({ data: ERROR_MESSAGE(response.message) }));
      }
    }
  } catch (error) {
    console.error("Login error:", error);
    yield put(
      apiError({
        data:
          error.message ||
          i18n.t("auth.login.unknownError", { detail: JSON.stringify(error) }),
      })
    );
  }
}

function* logoutUser() {
  try {
    // Call logout API first (before clearing storage)
    try {
      yield call(() =>
        api.delete(`${process.env.REACT_APP_API_BASE_URL}/auth/logout`)
      );
    } catch (apiError) {
      // Log but don't block logout if API fails
      console.warn(
        "Logout API failed (continuing with local logout):",
        apiError.message || apiError
      );
    }

    // Reset profile switch state
    yield put(
      updateProfileSwitch({
        isUserSwitch: false,
        email: "",
        company: "",
      })
    );

    // Remove authorization header
    removeAuthorization();

    // Clear all storage
    localStorage.clear();
    sessionStorage.clear();

    // Dispatch success action
    yield put(logoutUserSuccess());
  } catch (error) {
    console.error("Logout error:", error);
    // Even if logout fails, we should still complete the logout process
    removeAuthorization();
    yield put(logoutUserSuccess());
  }
}

function* authSaga() {
  yield takeEvery(LOGIN_USER, loginUser);
  yield takeEvery(LOGOUT_USER, logoutUser);
}

export default authSaga;
